import actions from './actions'

export default function PartOrderArrivedsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PARTORDERARRIVED:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PARTORDERARRIVED:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PARTORDERARRIVED:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PARTORDERARRIVED:
      return {
        ...state,
        editing: { partOrderArrivedID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PARTORDERARRIVED_RECIEVED ||
      actions.UPDATE_PARTORDERARRIVED_RECIEVED ||
      actions.DELETE_PARTORDERARRIVED_RECIEVED:
      return {
        ...state,
        editing: { partOrderArrivedID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
